import { environment } from 'src/environments/environment.dev3';

const authUrl = environment.BaseUrl + 'accounts/';
export const login = authUrl + 'login';
export const signup = authUrl + 'signup';
export const resetPassword = authUrl + 'resetPassword';
